import script from "./SummaryEventsList.vue?vue&type=script&setup=true&lang=js"
export * from "./SummaryEventsList.vue?vue&type=script&setup=true&lang=js"

import "./SummaryEventsList.vue?vue&type=style&index=0&id=5a04a41e&scoped=true&lang=css"
import "./SummaryEventsList.vue?vue&type=style&index=1&id=5a04a41e&lang=css"

import exportComponent from "C:\\Users\\jenkinsuser\\AppData\\Local\\Jenkins\\.jenkins\\workspace\\UI\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a04a41e"]])

export default __exports__